module.exports = __webpack_public_path__ + "img/banner-08.173b8df9.jpg";